import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Expensecategory = apiContainer.Expensecategory
//GET--->
// Corrected getExpensecategory function
export async function getExpensecategoryApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Expensecategory}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createExpensecategory(request) {
    try {
        return api.create(`${Expensecategory}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateExpensecategory(request, ExpensecategoryId) {
    try {
        return api.update(`${Expensecategory}/${ExpensecategoryId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteExpensecategory(ExpensecategoryId) {
    try {
        return api.delete(`${Expensecategory}/${ExpensecategoryId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



